import React, { useState, useEffect, useLayoutEffect } from "react";
import { Route, withRouter } from "react-router";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//img
import icon from "../../Assets/HomeIcons/iconBox1.svg";
import FullSidebarHelp from "../../Container/FullPageSidebar/help";

// -- redux
import { connect } from "react-redux";
import {
  GetHelp,
  UpdateHelpStatus,
  GetHelpDetails,
  UpdateHelpOrderStatus,
} from "../../Redux/Actions/HelpAction";
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";

function Help(props) {
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [InitialArray, setInitialArray] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [HelpId, setHelpId] = useState(false);
  const [update, SetUpdate] = useState(false);
  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;
  const [CardsArray, setCardsArray] = useState([]);

  const changePage = (e, id) => {
    e.preventDefault();
    props.history.push({
      pathname: "/dashboard/help/edit-help",
      state: id,
    });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(CardsArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCardsArray(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.title === arr.title);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
      });
    });
    props.UpdateHelpOrderStatus(data);
  };

  useEffect(() => {
    props.clear("clear");
    props.GetHelp();
  }, [props.status_data, props.add_data, props.edit_data, props.delete_data]);

  useEffect(() => {
    if (props.data && props.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setInitialArray(props.data.data.data);
      setTimeout(function () {
        props.clear("");
      }, 1000);
    }
  }, [
    props.data,
    props.status_data,
    props.add_data,
    props.edit_data,
    props.delete_data,
  ]);

  useEffect(() => {
    props.clear("clear");
  }, []);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      setCardsArray(InitialArray);
    }
  }, [
    props.status_data,
    InitialArray,
    props.add_data,
    props.edit_data,
    props.delete_data,
  ]);

  useEffect(() => {
    if (!props.Search) {
      setCardsArray(InitialArray);
    }
    if (props.Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postName = post.title;
        return postName.toLowerCase().includes(props.Search.toLowerCase());
      });
      setCardsArray(FilteredArray);
    }
  }, [props.Search]);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setHelpId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: HelpId,
        status: 0,
      };
      props.UpdateHelpStatus(data);
      setTimeout(function () {
        SetUpdate(!update);
      }, 1000);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: HelpId,
        status: 1,
      };
      props.UpdateHelpStatus(data);
      setTimeout(function () {
        SetUpdate(!update);
      }, 1000);
    } else {
      setModal(!OpenModal);
    }
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "add" &&
        props.add_data
      ) {
        let res = props.add_data;
        res.message = res.message.replace("Service", "Help");
        props.respType({
          type: "Help",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.add_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "delete" &&
        props.delete_data
      ) {
        let res = props.delete_data;
        res.message = res.message.replace("Service", "Help");
        props.respType({
          type: "Help",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.delete_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "update" &&
        props.edit_data
      ) {
        let res = props.edit_data;
        res.message = res.message.replace("Service", "Help");
        props.respType({
          type: "Help",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.edit_data]);

  return (
    <>
      {props.loading && <Loader />}
      <Route
        exact
        path={["/dashboard/help/add-help", "/dashboard/help/edit-help"]}
        component={FullSidebarHelp}
      />
      {props.location.pathname === "/dashboard/help" && (
        <>
          {CardsArray.length > 0 ? (
            <div className="box-wrap ml-4 mr-4">
              <DragDropContext onDragEnd={handleOnDragEnd}>
                {CardsArray.map((item, index) => {
                  return (
                    <Droppable
                      className="box-grid m-4"
                      key={item.id}
                      droppableId={item.id.toString()}
                      type="listing"
                    >
                      {(provided) => (
                        <div
                          className="box-content"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                key={item.id}
                                className="h-100"
                              >
                                <div
                                  className="box-content light-grey-background h-100"
                                  style={{ maxHeight: "350px" }}
                                >
                                  <div className="box h-100 position-relative pb-5 mb-5">
                                    <div className="box-header dark-background d-flex align-items-center p-3">
                                      <img
                                        src={item.icon}
                                        alt="icon"
                                      />
                                      <h6 className="text-white box-title m-0 ml-3">
                                        {item.title}
                                      </h6>
                                    </div>
                                    <div className="box-content m-3">
                                      <div className="d-flex justify-content-between mb-3">
                                        <div className="type">
                                          <label className="box-type-para text-grey-6 f-14 m-0">
                                            Type
                                          </label>
                                          <p className="text-white f-16 m-0">
                                            {item.type === 3 && "Service"}
                                            {item.type === 4 && "WebView"}
                                            {item.type === 5 && "Form"}
                                            {item.type === 6 && "Mobile"}
                                            {item.type === 7 && "Email"}
                                            {item.type === 8 && "Message"}
                                          </p>
                                        </div>
                                      </div>
                                      {item.type !== 5 && (
                                        <div className="d-flex justify-content-between mb-3">
                                          <div className="user-type">
                                            <label className="box-type-para text-grey-6 f-14 m-0">
                                              Key
                                            </label>
                                            <p className="text-white f-16 m-0">
                                              {item.information === "21" &&
                                                "Primis Banking"}
                                              {item.information === "1" &&
                                                "Home"}
                                              {item.information === "2" &&
                                                "Products"}
                                              {item.information === "3" &&
                                                "Services"}
                                              {item.information === "4" &&
                                                "Social"}
                                              {item.information === "5" &&
                                                "Help"}
                                              {item.information === "11" &&
                                                "Change Name"}
                                              {item.type === 7 &&
                                                item.information}
                                              {item.type === 4 &&
                                                item.information}
                                              {item.type === 6 &&
                                                item.information}
                                              {item.type === 8 &&
                                                item.information}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        width: "90%",
                                        bottom: "15px",
                                        left: "15px",
                                      }}
                                      className="box-footer position-absolute d-flex justify-content-between align-items-end"
                                    >
                                      <div>
                                        <p
                                          className={
                                            item.status
                                              ? "text-green label-para f-12"
                                              : "text-grey label-para f-12"
                                          }
                                        >
                                          {item.status ? "Enabled" : "Disabled"}
                                        </p>
                                        <label className="switch mb-0">
                                          <input
                                            type="checkbox"
                                            checked={item.status}
                                            readOnly
                                          />
                                          <span
                                            className="slider round"
                                            onClick={(e) =>
                                              handleModal(
                                                e,
                                                item.status === 1
                                                  ? "enable"
                                                  : "disable",
                                                item.title,
                                                item.id
                                              )
                                            }
                                          />
                                        </label>
                                      </div>

                                      <button
                                        onClick={(e) => changePage(e, item.id)}
                                        className="green-background edit-button f-14"
                                      >
                                        Edit
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        </div>
                      )}
                    </Droppable>
                  );
                })}
              </DragDropContext>

              {OpenModal && (
                <Modal
                  Name={Name}
                  Type={OpenModal}
                  Close={(e, type) => CloseModal(e, type)}
                />
              )}
            </div>
          ) : (
            <div className="d-flex text-center justify-content-center">
              <p className="m-0 text-white">Nothing found</p>
            </div>
          )}
        </>
      )}
    </>
  );
}

const mapStateToProps = ({ HelpReducer }) => {
  const {
    loading,
    data,
    status_data,
    add_data,
    edit_data,
    delete_data,
    details_data,
  } = HelpReducer;
  return {
    loading,
    data,
    status_data,
    add_data,
    edit_data,
    delete_data,
    details_data,
  };
};

const mapDispatchToProps = {
  GetHelp,
  UpdateHelpStatus,
  GetHelpDetails,
  UpdateHelpOrderStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help));
